// make constants accessible via this.$constants.constantName (omit 'this' if using inside <template>)
import { PRODUCT_CATEGORY } from '@/constants/constants.js'
import { ROUTE_NAME } from '@/constants/route.constants.js'
import { AgentLevel, AppointmentType, OTP_Type, ProductDealType, ProductDealTypeString } from '@/constants/enums'

//ToDo: remove in future as in data will get from API
import { stylists, salonBusinessHours } from '@/constants/placeholders'

let constPlugin = {}

constPlugin.install = function (Vue) {
  Vue.prototype.$constants = {
    PRODUCT_CATEGORY,
    ROUTE_NAME,
    AgentLevel,
    AppointmentType,
    OTP_Type,
    ProductDealType,
    ProductDealTypeString,
    stylists,
    salonBusinessHours
  }
}

export default constPlugin
